import { getApi } from "../helpers/api";

async function execute(endpoint: string, data: any) {
  return await getApi().post(`/${endpoint}`, data);
}

export default execute;
